import ActionTypes from '../actions/actionTypes';
import { getExtrasList, getRemainingRecipients, isDigitalCartOnly } from '../features/ampol-cash/helpers/cash-order-helper';

const initialState = {
  cashOrdersListLoading: false,
  cashOrdersListLoaded: false,
  cashOrdersListError: false,
  cashOrdersList: [],
  cashOrdersResultSize: 0,
  cashOrderCardDetails: null,

  cashOrderDetailsLoading: false,
  cashOrderDetailsLoaded: false,
  cashOrderDetailsError: false,
  cashOrderDetails: null,
  cashOrderCardDetailsPageNumber: 1,
  currentCashOrderCardDetailsPageNumber: 1,

  cashCardDetailsLoading: false,
  cashCardDetailsLoaded: false,
  cashCardDetailsError: false,
  cashCardDetails: null, 

  cashOrderDefaults: null,
  cashOrderDefaultsLoading: false,
  cashOrderDefaultsLoaded: false,
  cashOrderDefaultsError: false,

  cashCartItems: {},
  cashCartSubTotal: 0,
  cashCartShippingMethod: null,
  cashCartShippingCost: null,
  isFeeWaiveOverride: false,
  cashCartDiscount: null,
  cashCartTotal: null,
  isDigitalCartOnly: false,

  cashCartRequestedName: null,
  cashCartRequestedPhone: null,
  cashCartCaseNumber: null,
  cashCartPurchaseOrderNumber: null,
  cashOrderDeliveryOption: null,
  cashOrderSingleShippingAddress: null,
  cashOrderPhysicalAddressRecipient: null,

  createCashOrderLoading: false,
  createCashOrderLoaded: false,
  createCashOrderError: false,
  createCashOrderResponse: null,

  activateAllEnabled: false,
  activateAllCardsLoading: false,
  activateAllCardsLoaded: false,
  activateAllCardsError: false,

  cashModalStepId: 1,
};

export function cashReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.CASH.ORDERS_LIST.REQUEST:
      return {
        ...state,
        cashOrdersListLoading: true,
        cashOrdersListLoaded: false,
        cashOrdersListError: false,
      };
    case ActionTypes.CASH.ORDERS_LIST.SUCCESS:
      return {
        ...state,
        cashOrdersListLoading: false,
        cashOrdersListLoaded: true,
        cashOrdersList: payload.cashOrdersList,
        cashOrdersListResultSize: payload.cashOrdersListResultSize,
        cashOrderCardDetails: payload.cashOrderCardDetails,
      };
    case ActionTypes.CASH.ORDERS_LIST.FAILURE:
      return {
        ...state,
        cashOrdersListLoading: false,
        cashOrdersListError: true,
      };
    case ActionTypes.CASH.ORDERS_LIST.RESET:
      return {
        ...state,
        cashOrdersListLoading: false,
        cashOrdersListLoaded: false,
        cashOrdersListError: false,
        cashOrdersList: [], 
        cashOrdersListResultSize: 0,
        cashOrderCardDetails: null,
      };
    case ActionTypes.CASH.ORDER_DETAILS.REQUEST:
      return {
        ...state,
        cashOrderDetailsLoading: true,
        cashOrderDetailsLoaded: false,
        cashOrderDetailsError: false,
        activateAllEnabled: false,
        cashOrderDetails: null,
      };
    case ActionTypes.CASH.ORDER_DETAILS.SUCCESS:
      return {
        ...state,
        cashOrderDetailsLoading: false,
        cashOrderDetailsLoaded: true,
        cashOrderDetails: payload.cashOrderDetails,
        currentCashOrderCardDetailsPageNumber: payload.currentCashOrderCardDetailsPageNumber,
        activateAllEnabled: payload.cashOrderDetails?.hasInactiveCards,
      };
    case ActionTypes.CASH.ORDER_DETAILS.FAILURE:
      return {
        ...state,
        cashOrderDetailsLoading: false,
        cashOrderDetailsError: true,
      };
    case ActionTypes.CASH.ORDER_DETAILS.RESET:
      return {
        ...state,
        cashOrderDetailsLoading: false,
        cashOrderDetailsLoaded: false,
        cashOrderDetailsError: false,
        activateAllEnabled: false,
        cashOrderDetails: null,
      };
    case ActionTypes.CASH.CARD_DETAILS.REQUEST:
      return {
        ...state,
        cashCardDetailsLoading: true,
        cashCardDetailsLoaded: false,
        cashCardDetailsError: false,
        cashCardDetails: null,
      };
    case ActionTypes.CASH.CARD_DETAILS.SUCCESS:
      return {
        ...state,
        cashCardDetailsLoading: false,
        cashCardDetailsLoaded: true,
        cashCardDetails: payload.cashCardDetails,
      };
    case ActionTypes.CASH.CARD_DETAILS.FAILURE:
      return {
        ...state,
        cashCardDetailsLoading: false,
        cashCardDetailsError: true,
      };
    case ActionTypes.CASH.CARD_DETAILS.RESET:
      return {
        ...state,
        cashCardDetailsLoading: false,
        cashCardDetailsLoaded: false,
        cashCardDetailsError: false,
        cashCardDetails: null,
      };
    case ActionTypes.CASH.ADD_CART_ITEM:
      // eslint-disable-next-line no-case-declarations,no-unused-vars
      const addCashCartItems = {
        ...state.cashCartItems,
        [payload.cartItem.uuid]: {
          ...payload.cartItem,
          recipients: payload.cartItem.mediaType === 'D' ? [] : null,
          remainingRecipients: payload.cartItem.mediaType === 'D' ? getRemainingRecipients(payload.cartItem) : null
        }
      };

      return {
        ...state,
        cashCartSubTotal: state.cashCartSubTotal + payload.cartItem.total,
        cashCartItems: addCashCartItems,
        isDigitalCartOnly: isDigitalCartOnly(addCashCartItems)
      };
    case ActionTypes.CASH.EDIT_CART_ITEM: {
      const isValidRecipients = getRemainingRecipients(payload.cartItem) >= 0;
      // eslint-disable-next-line no-case-declarations,no-unused-vars
      const editCashCartItems = {
        ...state.cashCartItems,
        [payload.cartItem.uuid]: {
          ...payload.cartItem,
          recipients: payload.cartItem.mediaType === 'P'
            ? null
            : payload.cartItem.recipients && isValidRecipients
              ? payload.cartItem.recipients
              : [],
          remainingRecipients: payload.cartItem.mediaType === 'D' ? (getRemainingRecipients(isValidRecipients ? payload.cartItem : { ...payload.cartItem, recipients: [] })) : null,
        }
      };

      return {
        ...state,
        cashCartSubTotal: (state.cashCartSubTotal - state.cashCartItems[payload.cartItem.uuid].total) + payload.cartItem.total,
        cashCartItems: editCashCartItems,
        isDigitalCartOnly: isDigitalCartOnly(editCashCartItems)
      };
    }
    case ActionTypes.CASH.EDIT_CART_MEDIA_TYPE: {
      // eslint-disable-next-line no-case-declarations,no-unused-vars
      let editCashCartItems = Object.keys(state.cashCartItems).map(uuid => {
        const item = state.cashCartItems[uuid];
        const extras = item.extras.filter(extra => getExtrasList(payload.mediaType === 'D').some(item => item.value === extra));
        const isFuel = extras?.some(x => x === 'fuel');
        // PIN is a mandatory selection if cart item denomination >= 1000
        const isPin = extras?.some(x => x === 'pin') || (payload.mediaType === 'P' && (item?.denominationCode >= 1000 || item?.denomination >= 1000));
        const newExtras = [isFuel && 'fuel', isPin && 'pin'].filter(Boolean);

        return {
          ...item,
          mediaType: payload.mediaType,
          extras: newExtras,
          isFuelOnly: isFuel,
          verificationType: isPin ? 'P' : 'N',
          recipients: payload.mediaType === 'P' ? null : [],
          remainingRecipients: payload.mediaType === 'P' ? null : item?.quantity,
        };
      });

      editCashCartItems = Object.fromEntries(editCashCartItems.map(item => [item.uuid, item]));

      return {
        ...state,
        cashCartItems: editCashCartItems,
        isDigitalCartOnly: isDigitalCartOnly(editCashCartItems)
      };
    }
    case ActionTypes.CASH.DEL_CART_ITEM:
      // eslint-disable-next-line no-case-declarations,no-unused-vars
      const { [payload.cartItemId]: ignored, ...remainingItems } = state.cashCartItems;

      return {
        ...state,
        cashCartSubTotal: state.cashCartSubTotal - state.cashCartItems[payload.cartItemId].total,
        cashCartItems: remainingItems,
        isDigitalCartOnly: isDigitalCartOnly(remainingItems)
      };
    case ActionTypes.CASH.RESET_ORDER:
      return {
        ...state,
        cashCartItems: {},
        cashCartSubTotal: 0,
        cashCartShippingMethod: null,
        cashCartShippingCost: null,
        isFeeWaiveOverride: false,
        cashCartDiscount: null,
        cashCartTotal: null,
        isDigitalCartOnly: false,

        cashCartRequestedName: null,
        cashCartRequestedPhone: null,
        cashCartCaseNumber: null,
        cashCartPurchaseOrderNumber: null,
        cashOrderDeliveryOption: null,
        cashOrderSingleShippingAddress: null,
        cashOrderPhysicalAddressRecipient: null,

        createCashOrderLoading: false,
        createCashOrderLoaded: false,
        createCashOrderError: false,
        createCashOrderResponse: null,
      };
    case ActionTypes.CASH.ORDER_DEFAULTS.REQUEST:
      return {
        ...state,
        cashOrderDefaultsLoading: true,
        cashOrderDefaultsLoaded: false,
        cashOrderDefaultsError: false,
        cashOrderDefaults: null,
      };
    case ActionTypes.CASH.ORDER_DEFAULTS.SUCCESS:
      return {
        ...state,
        cashOrderDefaultsLoading: false,
        cashOrderDefaultsLoaded: true,
        cashOrderDefaults: payload.cashOrderDefaults,
      };
    case ActionTypes.CASH.ORDER_DEFAULTS.FAILURE:
      return {
        ...state,
        cashOrderDefaultsLoading: false,
        cashOrderDefaultsLoaded: false,
        cashOrderDefaultsError: true,
      };
    case ActionTypes.CASH.SET_SHIPPING_METHOD:
      return {
        ...state,
        cashCartShippingMethod: payload.shippingMethod,
        cashCartShippingCost: payload.shippingCost,
      };
    case ActionTypes.CASH.SET_ORDER_DISCOUNT:
      return {
        ...state,
        cashCartDiscount: payload.discountPercent,
      };
    case ActionTypes.CASH.SET_ADDITIONAL_INFORMATION:
      return {
        ...state,
        cashCartRequestedName: payload.requestedName,
        cashCartRequestedPhone: payload.requestedPhone,
        cashCartCaseNumber: payload.caseNumber,
        cashCartPurchaseOrderNumber: payload.purchaseOrderNumber,
      };
    case ActionTypes.CASH.SET_SHIPPING_WAIVED:
      return {
        ...state,
        isFeeWaiveOverride: payload.isFeeWaiveOverride,
      };
    case ActionTypes.CASH.SET_DELIVERY_OPTION:
      return {
        ...state,
        cashOrderDeliveryOption: payload.option,
      };
    case ActionTypes.CASH.SET_SINGLE_SHIPPING_ADDRESS:
      return {
        ...state,
        cashOrderSingleShippingAddress: payload.address,
      };
    case ActionTypes.CASH.SET_PHYSICAL_ADDRESS_RECIPIENT:
      return {
        ...state,
        cashOrderPhysicalAddressRecipient: payload.recipient
      };
    case ActionTypes.CASH.REMOVE_PHYSICAL_ADDRESS_RECIPIENT:
      return {
        ...state,
        cashOrderPhysicalAddressRecipient: null
      };
    case ActionTypes.CASH.SET_CART_ITEM_RECIPIENT:
      // eslint-disable-next-line no-case-declarations
      const cartItemWithUpdatedRecipient = { ...state.cashCartItems[payload.cartItemUuid] };
      // eslint-disable-next-line no-case-declarations
      const recipientIndex = cartItemWithUpdatedRecipient.recipients.findIndex(recipient => recipient.uuid === payload.recipient.uuid);

      if (recipientIndex === -1) {
        cartItemWithUpdatedRecipient.recipients = cartItemWithUpdatedRecipient.recipients
          .concat(payload.recipient);
      } else {
        cartItemWithUpdatedRecipient.recipients = cartItemWithUpdatedRecipient.recipients.map(recipient =>
          recipient.uuid === payload.recipient.uuid ? payload.recipient : recipient
        );
      }

      return {
        ...state,
        cashCartItems: {
          ...state.cashCartItems,
          [payload.cartItemUuid]: {
            ...cartItemWithUpdatedRecipient,
            remainingRecipients: getRemainingRecipients(cartItemWithUpdatedRecipient)
          }
        }
      };
    case ActionTypes.CASH.REMOVE_CART_ITEM_RECIPIENT:
      // eslint-disable-next-line no-case-declarations
      const cartItemWithRemovedRecipient = { ...state.cashCartItems[payload.cartItemUuid] };

      cartItemWithRemovedRecipient.recipients = cartItemWithRemovedRecipient.recipients
        .filter(recipient => recipient.uuid !== payload.recipient.uuid);

      return {
        ...state,
        cashCartItems: {
          ...state.cashCartItems,
          [payload.cartItemUuid]: {
            ...cartItemWithRemovedRecipient,
            remainingRecipients: getRemainingRecipients(cartItemWithRemovedRecipient)
          }
        }
      };
    case ActionTypes.CASH.CREATE_ORDER.REQUEST:
      return {
        ...state,
        createCashOrderLoading: true,
        createCashOrderLoaded: false,
        createCashOrderError: false,
        createCashOrderResponse: null,
      };
    case ActionTypes.CASH.CREATE_ORDER.SUCCESS:
      return {
        ...state,
        createCashOrderLoading: false,
        createCashOrderLoaded: true,
        createCashOrderResponse: payload.createCashOrderResponse,
      };
    case ActionTypes.CASH.CREATE_ORDER.FAILURE:
      return {
        ...state,
        createCashOrderLoading: false,
        createCashOrderError: true,
      };
    case ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.REQUEST:
      return {
        ...state,
        activateAllCardsLoading: true,
        activateAllCardsLoaded: false,
        activateAllCardsError: false,
      };
    case ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.SUCCESS:
      return {
        ...state,
        activateAllCardsLoading: false,
        activateAllCardsLoaded: true,
      };
    case ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.FAILURE:
      return {
        ...state,
        activateAllCardsLoading: false,
        activateAllCardsError: true,
      };
    case ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.RESET:
      return {
        ...state,
        activateAllCardsLoading: false,
        activateAllCardsLoaded: false,
        activateAllCardsError: false,
      };
    case ActionTypes.CASH.SET_ORDER_CARD_DETAILS_PAGE_NUMBER:
      return {
        ...state,
        cashOrderCardDetailsPageNumber: payload.pageNumber,
      };
    case ActionTypes.CASH.SET_MODAL_STEP:
      return {
        ...state,
        cashModalStepId: payload.stepId,
      };
    default:
      return state;
  }
}
